import React from 'react';
import {Field, FieldArray, Form, Formik} from 'formik';
import * as Yup from 'yup';
import {connect} from 'react-redux';
import {equipoService} from '../../../_services';
import {Col, Row, Table} from 'react-bootstrap';
import Select from 'react-select';
import {alertActions, equipoActions, utilActions} from '../../../_actions';
import {ErrorMessage, LoadingBoton} from '../../../_helpers';
import {FormEditarSensor} from '../../Sensor/FormEditarSensor';
import Switch from "react-switch";
import {empresaActions} from '../../../_actions/empresa.actions';

class FormNuevoEquipo extends React.Component {


    state = {
        sensor: {},
        showSensor: false,
        grabando: false
    };

    componentDidMount() {
        if (this.props.tiposSensores === undefined) this.props.traerTiposSensores();
        if (this.props.empresas === undefined) this.props.traerEmpresas();
    }


    nuevoSensor = (sensor, arrayHelpers, index) => {
        this.setState(() => {
            return {index: index, showSensor: true, sensor: sensor, arrayHelpers: arrayHelpers};
        });
    }

    setGrabando = (grab) => {
        this.setState({grabando: grab});
    }

    handleClose = () => {
        this.setState({showSensor: false});
    };


    armarNombreWidget = (sensor) => {
        let nombreFinal = '';
        sensor.shadows.forEach(shadow => {
            nombreFinal = nombreFinal + shadow.tipoWidget?.descripcion + ','
        });

        return nombreFinal.substring(0, nombreFinal.length - 1);
    };


    render() {

        const {equipo, empresas} = this.props;

        let esNuevo = false;
        if (utilActions.isEmpty(equipo))
            esNuevo = true

        let inic = {
            id: '',
            nombre: '',
            asignado: false,
            empresa: {id: ''},
            sensores: []
        }
        const sensoresValidationSchema = Yup.object().shape({
            labelUsuario: Yup.string().required('Es requerido'),
            tipoSensor: Yup.string().required('Es requerido')
        });


        const validationSchema = Yup.object().shape({
            nombre: Yup.string()
                .min(2, 'Muy corto')
                .max(50, 'Too Long!')
                .required('Requerido'),
            sensores: Yup.array().of(sensoresValidationSchema)
        });

        if (equipo !== undefined) inic = utilActions.setearValores(inic, equipo);

        return (

            <div>
                <Formik
                    enableReinitialize={true}
                    initialValues={inic}
                    validationSchema={validationSchema}
                    onSubmit={values => {
                        this.setGrabando(true);
                        equipoService.grabarEquipo(values).then(
                            data => {
                                this.props.getEquiposPU();
                                this.props.handleClose();
                                this.setGrabando(false);
                            },
                            error => {
                                this.props.enviarError(error.message);
                                this.setGrabando(false);
                            }
                        );

                    }}
                >
                    {({errors, touched, values, setFieldValue}) => (
                        <Form>
                            <Row>
                                <Col xs="6">
                                    <label className="font-weight-bold" htmlFor="nombre">Nombre del
                                        equipo </label><ErrorMessage name={`nombre`}/>
                                    <Field name="nombre"/>
                                </Col>
                                <Col xs="6">
                                    <label className="font-weight-bold" htmlFor="asignado">Reservado </label>
                                    <ErrorMessage name={`asignado`}/>
                                    <br></br><Switch onChange={(event) => setFieldValue('asignado', event)}
                                                     checked={values.asignado}/>
                                </Col>

                                <Col xs="6">
                                    <label className="font-weight-bold" htmlFor="asignado">Empresa </label>
                                    <ErrorMessage name={`empresa`}/>
                                    <Select
                                        isClearable
                                        isMulti={false}
                                        value={empresas ? empresas.filter(obj => values.empresa.id == obj.id) : []}
                                        name={`empresa`}
                                        getOptionLabel={option => `${option.nombre}`}
                                        getOptionValue={option => option.id}
                                        onChange={so => {
                                            setFieldValue(`empresa`, so ? so : [])
                                        }}
                                        isSearchable={true}
                                        placeholder="Seleccione"
                                        options={empresas}
                                    />
                                </Col>

                            </Row>
                            <Row>
                                <FieldArray
                                    name="sensores"
                                    render={arrayHelpers => (
                                        <div className="form-body mt-4 mb-4">
                                            <Col xs={12}>
                                                <button className="btns btns-fucsia btns-sm" type="button"
                                                        onClick={() => this.nuevoSensor({}, arrayHelpers, undefined)}>
                                                    <i className="material-icons align-middle txt-16">add</i> Nuevo
                                                    sensor
                                                </button>
                                            </Col>
                                            <Col className="mb-5 mt-4">
                                                <Table className="sombra-1" responsive hover>
                                                    <thead className="bg-silver">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Nombre</th>
                                                        <th>Nombre topic</th>
                                                        <th>Widget</th>
                                                        <th>Valor encendido - Valor apagado</th>
                                                        <th></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {values.sensores && values.sensores.map((sen, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    {sen.id}
                                                                </td>
                                                                <td>
                                                                    {sen.labelUsuario}
                                                                </td>
                                                                <td>
                                                                    {sen.nombreNexo}
                                                                </td>
                                                                <td>
                                                                    {this.armarNombreWidget(sen)}
                                                                </td>
                                                                <td>
                                                                    {sen.valorEncendido} - {sen.valorApagado}
                                                                </td>
                                                                <td>
                                                                    <button className="btns btns-link text-info"
                                                                            type="button"
                                                                            onClick={() => this.nuevoSensor(sen, arrayHelpers, index)}>
                                                                        <i className="fas fa-pencil-alt"></i>
                                                                    </button>
                                                                    <button className="btns btns-link text-danger"
                                                                            type="button"
                                                                            onClick={() => arrayHelpers.remove(index)}>
                                                                        <i className="fas fa-trash"></i>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    )
                                                    }
                                                    </tbody>
                                                </Table>
                                            </Col>
                                        </div>
                                    )}
                                />
                            </Row>
                            <div className="justify-content-center mt-5 p-3 row border-top bg-light">
                                <button className="btn btn-link text-secundario cursor mr-3" type="button"
                                        onClick={() => this.props.handleClose()}>
                                    <i className="icon-times"></i> Cerrar
                                </button>
                                <button className="btns btns-secundario" type="submit" disabled={this.state.grabando}>
                                    <i className="icon-floppy"></i> Grabar <LoadingBoton
                                    grabando={this.state.grabando}/>
                                </button>
                            </div>
                        </Form>
                    )}
                </Formik>

                {this.state.showSensor &&
                <FormEditarSensor esAdmin={true} index={this.state.index} arrayHelpers={this.state.arrayHelpers}
                                  sensor={this.state.sensor} show={this.state.showSensor}
                                  handleClose={this.handleClose}/>}
            </div>
        )
    };
}


function mapState(state) {
    const {empresas} = state.empresa;
    const {tiposSensores} = state.equipos;
    return {tiposSensores, empresas};
}

const actionCreators = {
    getEquiposPU: equipoActions.getEquiposPU,
    enviarError: alertActions.enviarError,
    traerTiposSensores: equipoActions.traerTiposSensores,
    traerEmpresas: empresaActions.traerEmpresas

}

const connectedFormNuevoEquipo = connect(mapState, actionCreators)(FormNuevoEquipo);
export {connectedFormNuevoEquipo as FormNuevoEquipo};